import Loadable from 'react-loadable';

import LoadingModal from 'modals/LoadingModal';

export const SelectContentBlockModalContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "SelectContentBlockModalContainer" */
      './SelectContentBlockModalContainer.dynamic'
    ),
  loading: LoadingModal,
});
